import { NonNullableRouteInformationType } from './RouteInformationTypes.ts'
import {
  CATEGORIES_ROUTE,
  SUGGEST_TO_REGION_ROUTE,
  EXTERNAL_SOURCES_ROUTE,
  IMPRINT_ROUTE,
  EVENTS_ROUTE,
  REGIONS_ROUTE,
  OPEN_SOURCE_ROUTE,
  MAIN_IMPRINT_ROUTE,
  NEWS_ROUTE,
  PLACES_ROUTE,
  SEARCH_ROUTE,
} from './index.ts'

type RegionContentRouteUrlType = {
  regionCode: string
  languageCode: string
  route?: string
  path?: string | null | undefined
}

const constructPathname = (parts: (string | null | undefined)[]) => {
  const pathname = parts
    .filter(Boolean)
    .map(part => part?.toLowerCase())
    .join('/')
  return pathname.startsWith('/') ? pathname : `/${pathname}`
}

export const regionContentPath = ({ regionCode, languageCode, route, path }: RegionContentRouteUrlType): string =>
  constructPathname([regionCode, languageCode, route, path])

export const pathnameFromRouteInformation = (routeInformation: NonNullableRouteInformationType): string => {
  if (
    routeInformation.route === OPEN_SOURCE_ROUTE ||
    routeInformation.route === EXTERNAL_SOURCES_ROUTE ||
    routeInformation.route === MAIN_IMPRINT_ROUTE
  ) {
    // https://integreat.app/consent, https://integreat.app/licenses, https://integreat.app/main-imprint
    return constructPathname([routeInformation.route])
  }
  if (routeInformation.route === SUGGEST_TO_REGION_ROUTE) {
    // https://integreat.app/recommend
    return constructPathname([SUGGEST_TO_REGION_ROUTE, routeInformation.languageCode])
  }
  if (routeInformation.route === CATEGORIES_ROUTE) {
    // https://integreat.app/augsburg/de/, https://integreat.app/augsburg/de/willkommen/erste-schritte
    return constructPathname([routeInformation.regionContentPath])
  }
  if (routeInformation.route === EVENTS_ROUTE || routeInformation.route === PLACES_ROUTE) {
    const { regionCode, languageCode, route, slug } = routeInformation
    // https://integreat.app/augsburg/de/places, https://integreat.app/augsburg/de/events/my-event-1234
    return constructPathname([regionCode, languageCode, route, slug])
  }
  if (
    routeInformation.route === IMPRINT_ROUTE ||
    routeInformation.route === SEARCH_ROUTE ||
    routeInformation.route === NEWS_ROUTE
  ) {
    // https://integreat.app/augsburg/de/offers, https://integreat.app/augsburg/de/search, ...
    const { regionCode, languageCode } = routeInformation
    const newsId = routeInformation.route === NEWS_ROUTE ? routeInformation.id : null
    return constructPathname([regionCode, languageCode, routeInformation.route, newsId?.toString()])
  }
  // https://integreat.app/regions/de
  return constructPathname([REGIONS_ROUTE, routeInformation.languageCode])
}
